// src/pages/Yasal.jsx
// Kullanım Koşulları, Gizlilik Politikası, Çerez Politikası ve SSS tek dosyada

import { useNavigate, useParams } from "react-router-dom";
import YildizArkaplan from "../components/YildizArkaplan";

const ICERIKLER = {
  kullanim: {
    baslik: "Kullanım Koşulları",
    emoji: "📋",
    guncelleme: "1 Ocak 2025",
    bolumler: [
      {
        baslik: "⚠️ Önemli Uyarı",
        icerik: `Remil uygulamasında sunulan tüm fal, tarot, numeroloji, büyü ve benzeri içerikler yalnızca eğlence amaçlıdır. Bu içerikler gerçek bir kehanet, bilimsel tahmin veya profesyonel tavsiye niteliği taşımaz. Kullanıcılar bu içerikleri kişisel, finansal, hukuki veya tıbbi kararlarında esas alamaz. Uygulama, herhangi bir olayın gerçekleşeceğini garanti etmez.`
      },
      {
        baslik: "1. Genel Hükümler",
        icerik: `Remil uygulamasını ("Uygulama") kullanarak aşağıdaki kullanım koşullarını kabul etmiş sayılırsınız. Bu koşulları kabul etmiyorsanız uygulamayı kullanmayınız.

Remil, yapay zeka destekli eğlence amaçlı bir fal uygulamasıdır. Uygulama üzerinden sunulan tüm içerikler tamamen eğlence amaçlıdır ve kehanet, bilimsel tahmin veya gerçek bir öngörü niteliği taşımamaktadır.`
      },
      {
        baslik: "2. Hizmet Kapsamı",
        icerik: `Remil aşağıdaki hizmetleri sunar:
• Yapay zeka destekli kahve, el, yüz ve ilişki falı yorumları
• Token tabanlı ödeme sistemi
• Falcı karakterleriyle etkileşim
• Reklam izleyerek ücretsiz token kazanma

Tüm fal yorumları Claude yapay zeka modeli tarafından üretilmektedir. Bu yorumlar tamamen eğlence amaçlıdır; gerçek yaşam kararlarınızda esas alınmamalıdır.`
      },
      {
        baslik: "3. Kullanıcı Yükümlülükleri",
        icerik: `Kullanıcılar aşağıdaki kurallara uymakla yükümlüdür:
• 18 yaşından büyük olmak veya ebeveyn/vasi onayına sahip olmak
• Gerçek ve doğru bilgilerle kayıt olmak
• Uygulamayı kötüye kullanmamak, hacklemek veya manipüle etmemek
• Diğer kullanıcıların haklarına saygı göstermek
• Uygulamanın içeriklerini izinsiz kopyalamamak veya dağıtmamak`
      },
      {
        baslik: "4. Token ve Ödeme",
        icerik: `Token sistemi:
• Tokenlar uygulama içi sanal para birimidir, gerçek para değeri taşımaz
• Satın alınan tokenlar iade edilemez
• Token paketleri iyzico altyapısı üzerinden güvenli şekilde işlenir
• Hesap silinmesi durumunda kalan tokenlar iade edilmez

Remil, token fiyatlarını önceden bildirmek kaydıyla değiştirme hakkını saklı tutar.`
      },
      {
        baslik: "5. Sorumluluk Reddi",
        icerik: `Remil:
• Fal yorumlarının doğruluğunu, gerçekliğini veya güvenilirliğini garanti etmez
• Kullanıcıların fal yorumlarına dayanarak aldığı kararların sonuçlarından sorumlu değildir
• Teknik aksaklıklar, veri kaybı veya hizmet kesintilerinden doğan zararlardan sorumlu tutulamaz

Uygulama "olduğu gibi" sunulmaktadır.`
      },
      {
        baslik: "6. Fikri Mülkiyet",
        icerik: `Remil markası, logosu, tasarımı ve içerikleri Remil'e aittir. Kullanıcılar bu içerikleri izinsiz kullanamaz, kopyalayamaz veya dağıtamaz. Kullanıcıların uygulamaya yüklediği fotoğraflar yalnızca fal yorumu için kullanılır ve üçüncü şahıslarla paylaşılmaz.`
      },
      {
        baslik: "7. Hesap Feshi",
        icerik: `Remil, aşağıdaki durumlarda kullanıcı hesabını askıya alabilir veya silebilir:
• Kullanım koşullarının ihlali
• Dolandırıcılık veya kötüye kullanım tespiti
• Uzun süreli pasiflik (24 ay)

Kullanıcılar istedikleri zaman hesaplarını silebilir. Hesap silme işlemi geri alınamaz.`
      },
      {
        baslik: "8. İletişim",
        icerik: `Kullanım koşullarıyla ilgili sorularınız için:
E-posta: destek@remil.com.tr
Web: remil.com.tr`
      },
    ]
  },

  gizlilik: {
    baslik: "Gizlilik Politikası",
    emoji: "🔒",
    guncelleme: "1 Ocak 2025",
    bolumler: [
      {
        baslik: "1. Toplanan Veriler",
        icerik: `Remil aşağıdaki verileri toplar:

Hesap Bilgileri:
• E-posta adresi
• Görünen ad
• Profil fotoğrafı (opsiyonel)

Kullanım Verileri:
• Fal geçmişi ve yorumları
• Token hareketleri
• Uygulama kullanım istatistikleri

Teknik Veriler:
• Cihaz türü ve işletim sistemi
• IP adresi
• Çerezler ve oturum bilgileri`
      },
      {
        baslik: "2. Verilerin Kullanımı",
        icerik: `Toplanan veriler şu amaçlarla kullanılır:
• Hizmetin sağlanması ve iyileştirilmesi
• Yapay zeka fal yorumlarının kişiselleştirilmesi
• Kullanıcı desteği
• Güvenlik ve dolandırıcılık önleme
• Yasal yükümlülüklerin yerine getirilmesi

Verileriniz üçüncü şahıslara satılmaz veya kiralanmaz.`
      },
      {
        baslik: "3. Fotoğraf Verileri",
        icerik: `Fal için yüklenen fotoğraflar:
• Yalnızca yapay zeka fal yorumu için işlenir
• Anthropic'in Claude API'sine iletilir (işleme amaçlı)
• Sunucularımızda kalıcı olarak saklanmaz
• Üçüncü şahıslarla paylaşılmaz

Anthropic'in gizlilik politikası için: anthropic.com/privacy`
      },
      {
        baslik: "4. Veri Güvenliği",
        icerik: `Verileriniz Supabase altyapısında saklanmaktadır. Supabase, SOC 2 Type II sertifikalı, endüstri standardı güvenlik önlemlerine sahip bir platformdur. Tüm veriler şifrelenmiş bağlantılar (HTTPS/TLS) üzerinden iletilir.`
      },
      {
        baslik: "5. Kullanıcı Hakları",
        icerik: `KVKK kapsamında aşağıdaki haklara sahipsiniz:
• Verilerinize erişim hakkı
• Verilerinizin düzeltilmesini talep hakkı
• Verilerinizin silinmesini talep hakkı ("unutulma hakkı")
• Veri işlemeye itiraz hakkı
• Veri taşınabilirliği hakkı

Bu haklarınızı kullanmak için: destek@remil.com.tr`
      },
      {
        baslik: "6. Üçüncü Taraf Hizmetler",
        icerik: `Remil aşağıdaki üçüncü taraf hizmetleri kullanır:
• Supabase — veritabanı ve kimlik doğrulama
• Anthropic Claude — yapay zeka fal yorumları
• Google OAuth — Google ile giriş (opsiyonel)
• iyzico — ödeme işlemleri
• Yandex Ads — reklam hizmetleri

Her hizmetin kendi gizlilik politikası geçerlidir.`
      },
      {
        baslik: "7. İletişim",
        icerik: `Gizlilik konularında:
E-posta: gizlilik@remil.com.tr
Web: remil.com.tr/gizlilik`
      },
    ]
  },

  cerez: {
    baslik: "Çerez Politikası",
    emoji: "🍪",
    guncelleme: "1 Ocak 2025",
    bolumler: [
      {
        baslik: "Çerezler Nedir?",
        icerik: `Çerezler, web sitelerinin tarayıcınıza yerleştirdiği küçük metin dosyalarıdır. Remil, hizmetinin işleyişi için zorunlu çerezler kullanmaktadır.`
      },
      {
        baslik: "Kullandığımız Çerezler",
        icerik: `Zorunlu Çerezler:
• Oturum çerezleri — giriş durumunuzu korur
• Güvenlik çerezleri — CSRF saldırılarına karşı koruma

Analitik Çerezler:
• Kullanım istatistikleri — uygulamayı iyileştirmek için

Reklam Çerezleri:
• Yandex Ads — kişiselleştirilmiş reklam gösterimi için`
      },
      {
        baslik: "Çerez Kontrolü",
        icerik: `Tarayıcı ayarlarınızdan çerezleri yönetebilirsiniz. Zorunlu çerezleri devre dışı bırakmanız durumunda uygulama düzgün çalışmayabilir. Reklam çerezlerini Yandex Ads ayarlarından devre dışı bırakabilirsiniz.`
      },
    ]
  },

  mesafeli: {
    baslik: "Mesafeli Satış Sözleşmesi",
    emoji: "🛒",
    guncelleme: "1 Ocak 2025",
    bolumler: [
      { baslik: "Taraflar", icerik: "Satıcı: Remil App\nAlıcı: Hizmet satın alan kullanıcı" },
      { baslik: "Konu", icerik: "İşbu sözleşme, dijital token satın alımına ilişkin koşulları düzenler." },
      { baslik: "Ürün ve Fiyat", icerik: "100 Token - 99 TL\n300 Token - 250 TL\n750 Token - 500 TL" },
      { baslik: "Ödeme", icerik: "Ödemeler iyzico altyapısı üzerinden güvenli şekilde işlenir." },
      { baslik: "Teslimat", icerik: "Dijital içerik niteliğinde olan tokenlar, ödeme onayının ardından anında hesabınıza yüklenir." },
      { baslik: "Cayma Hakkı", icerik: "Dijital içeriklerin anında teslim edilmesi nedeniyle, içeriğe erişim sağlandıktan sonra cayma hakkı kullanılamaz." },
    ]
  },
  iptal: {
    baslik: "İptal ve İade Koşulları",
    emoji: "↩️",
    guncelleme: "1 Ocak 2025",
    bolumler: [
      { baslik: "Genel Kural", icerik: "Token satın alımları dijital içerik niteliğinde olup, satın alma işleminin tamamlanmasıyla birlikte cayma hakkı sona erer." },
      { baslik: "İstisna Durumlar", icerik: "Teknik hata veya çift ödeme durumlarında destek@remil.app adresine başvurabilirsiniz." },
      { baslik: "İletişim", icerik: "destek@remil.app\nYanıt süresi: 2 iş günü" },
    ]
  },
  'veri-silme': {
    baslik: "Veri Silme Talebi",
    emoji: "🗑️",
    guncelleme: "1 Ocak 2025",
    bolumler: [
      {
        baslik: "Veri Silme Talebi",
        icerik: `Remil hesabınızdaki verilerin silinmesini talep etmek için aşağıdaki adımları izleyebilirsiniz:

1. Silmek istediğiniz veri türünü belirleyin:
   - Sadece fal geçmişi
   - Profil bilgileri (ad, cinsiyet, avatar)
   - Tüm veriler ve hesap

2. noreply@remil.app adresine 'Veri Silme Talebi' konusuyla e-posta gönderin. E-postanızda kayıtlı e-posta adresinizi ve silmek istediğiniz veri türünü belirtin.

3. Talebiniz 30 iş günü içinde işleme alınır ve size e-posta ile bilgi verilir.

Saklama süreleri: Ödeme kayıtları yasal zorunluluk gereği 10 yıl saklanır. Diğer tüm veriler talep üzerine kalıcı olarak silinir.`
      },
    ]
  },
  sss: {
    baslik: "Sıkça Sorulan Sorular",
    emoji: "❓",
    guncelleme: "1 Ocak 2025",
    bolumler: [
      {
        baslik: "🔮 Fal Hakkında",
        icerik: `S: Falım ne zaman hazır olur?
C: Falcıya göre değişmekle birlikte genellikle 5-10 dakika içinde hazır olur. Hazır olduğunda bildirim alırsınız.

S: Hangi fotoğrafı yüklemeliyim?
C: Kahve falı için fincanın içini net gösteren bir fotoğraf, el falı için avuç içini net gösteren bir fotoğraf yükleyin. Net olmayan fotoğraflar fal kalitesini düşürür.

S: Fotoğraflarım saklanıyor mu?
C: Hayır. Fotoğraflarınız yalnızca fal yorumu için kullanılır ve kalıcı olarak saklanmaz.`
      },
      {
        baslik: "🪙 Token Hakkında",
        icerik: `S: Token nasıl kazanırım?
C: Üç yolla token kazanabilirsiniz:
• Kayıt bonusu: 50 token
• Reklam izleme: Her reklam için +30 token
• Token satın alma: Uygulama içi satın alma

S: Tokenlarım neden azaldı?
C: Her fal baktırma işleminde falcının token ücreti düşer. Fal gönderme sayfasında ücret görüntülenebilir.

S: Satın aldığım tokenlar iade edilir mi?
C: Kullanılmamış tokenlar teknik bir sorun olmadıkça iade edilmez. Sorun yaşarsanız destek@remil.com.tr adresine yazın.`
      },
      {
        baslik: "👤 Hesap Hakkında",
        icerik: `S: Şifremi unuttum, ne yapmalıyım?
C: Giriş ekranında "Şifremi Unuttum" seçeneğini kullanın. E-postanıza sıfırlama bağlantısı gönderilecektir.

S: Hesabımı nasıl silebilirim?
C: Profil → Ayarlar → Hesabı Sil seçeneğinden hesabınızı kalıcı olarak silebilirsiniz. Bu işlem geri alınamaz.

S: Google ile giriş yapabilir miyim?
C: Evet, giriş ekranındaki "Google ile Giriş Yap" butonu ile Google hesabınızla giriş yapabilirsiniz.`
      },
      {
        baslik: "📱 Teknik Hakkında",
        icerik: `S: Uygulama hangi cihazlarda çalışır?
C: Remil tüm modern tarayıcılarda ve mobil cihazlarda çalışır. iOS ve Android uygulaması yakında App Store ve Google Play'de yayınlanacaktır.

S: Bildirimler gelmiyor, ne yapmalıyım?
C: Tarayıcı veya cihaz bildirim ayarlarından Remil'e bildirim izni verdiğinizi kontrol edin.

S: Bir hata veya sorun bildirmek istiyorum.
C: destek@remil.com.tr adresine yazabilir veya uygulama içindeki geri bildirim formunu kullanabilirsiniz.`
      },
    ]
  }
};

export default function Yasal() {
  const { tip } = useParams(); // kullanim | gizlilik | cerez | sss
  const navigate = useNavigate();
  const icerik = ICERIKLER[tip];

  if (!icerik) return (
    <div style={{ color: "#fff", padding: 40, textAlign: "center" }}>Sayfa bulunamadı.</div>
  );

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative",
      fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420, margin: "0 auto",
    }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      <YildizArkaplan />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 90 }}>

        {/* Geri */}
        <div style={{ padding: "52px 24px 0" }}>
          <button onClick={() => navigate(-1)} style={{
            background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: 12, padding: "8px 16px", color: "rgba(255,255,255,0.7)",
            fontSize: 13, cursor: "pointer",
          }}>← Geri</button>
        </div>

        {/* Başlık */}
        <div style={{ padding: "24px 24px 8px" }}>
          <div style={{ fontSize: 28, marginBottom: 8 }}>{icerik.emoji}</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#fff", fontFamily: "Georgia, serif" }}>
            {icerik.baslik}
          </div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.3)", marginTop: 6 }}>
            Son güncelleme: {icerik.guncelleme}
          </div>
        </div>

        {/* İçerik */}
        <div style={{ padding: "16px 24px 0" }}>
          {icerik.bolumler.map((bolum, i) => (
            <div key={i} style={{
              background: "rgba(255,255,255,0.03)",
              border: "1px solid rgba(255,255,255,0.07)",
              borderRadius: 16, padding: "18px",
              marginBottom: 12,
            }}>
              <div style={{
                fontSize: 14, fontWeight: 700, color: "#C084FC",
                marginBottom: 10, fontFamily: "Georgia, serif",
              }}>
                {bolum.baslik}
              </div>
              <div style={{
                fontSize: 13, color: "rgba(255,255,255,0.65)",
                lineHeight: 1.8, whiteSpace: "pre-line",
              }}>
                {bolum.icerik}
              </div>
            </div>
          ))}
        </div>

        {/* İletişim */}
        <div style={{
          margin: "16px 24px 0",
          background: "rgba(168,85,247,0.08)", border: "1px solid rgba(168,85,247,0.2)",
          borderRadius: 16, padding: "16px", textAlign: "center",
        }}>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", marginBottom: 4 }}>
            Sorularınız için
          </div>
          <div style={{ fontSize: 14, color: "#C084FC", fontWeight: 600 }}>
            destek@remil.com.tr
          </div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.3)", marginTop: 4 }}>
            remil.com.tr
          </div>
        </div>
      </div>
    </div>
  );
}